import React from 'react';
import ValidCheck from './ValidityCheck';

export default function ValidityLabel(props) {
  const {children, valid} = props;

  return <label style={{ color: valid === false ? 'red' : undefined }}>{children} <ValidCheck valid={valid} /></label>
}
